import React, { Component } from 'react'
import { MuiGrid, MuiDialog, MuiDialogTitle,MuiTypography, MuiDialogContent, MuiButton, MuiFormControlLabel, MuiKeyboardArrowDown, MuiKeyboardArrowUp, } from '../../ui/MaterialUIComponents';
import theme from '../../../assests/theme/index';
import { BubbleComponent } from './index';
import lodashUtil from 'lodash';
import { gradePickerUtil } from './'
import { CheckBox } from '../../ui/customUIComponents'

export class GradePickerComponent extends Component {

	constructor(props) {
		super(props)
		this.state = {
			showDropDown: false,
			isAllChecked: true,
			isCheckboxClicked: true,
			isBubbleClicked: true,
		}
	}

	//TO SHOW AND HIDE THE GROUPS
	toggleDropDown = () => {
		if (this.state.showDropDown === false) {
			this.setState({ showDropDown: true });
		} else if (this.state.showDropDown === true) {
			this.setState({ showDropDown: false });
		}
	}

	handleDelete = () => {
		//write the logic to delete the subject component (slice)
	}

	// ALL NAMED CHECKBOX

	//When the all check box is true it loops over all the levels (gradeLevels, grades and groups) 
	//and toggles the true state to become false or vise versa.
	allCheckboxToggle = () => {
		if (this.props.gradeLevels.isAllChecked === false) {
			// FOR LOOP TO LOOP OVER GRADE LEVELS 
			for (let i = 0; i < this.props.gradeLevels.gradeLevels.length; i++) {
				this.props.gradeLevels.gradeLevels[i].isGradeLevelSelected = true;
				this.props.gradeLevels.gradeLevels[i].isGradeLevelIntermediate = false;
				// FOR LOOP TO LOOP OVER GRADE NUMBERS 
				for (let j = 0; j < this.props.gradeLevels.gradeLevels[i].grades.length; j++) {
					this.props.gradeLevels.gradeLevels[i].grades[j].isGradeSelected = true;
					// FOR LOOP TO LOOP OVER GROUPS 
					for (let k = 0; k < this.props.gradeLevels.gradeLevels[i].grades[j].groups.length; k++) {
						this.props.gradeLevels.gradeLevels[i].grades[j].groups[k].isGroupSelected = true;
						this.props.gradeLevels.gradeLevels[i].grades[j].groups[k].isGradeLevelIntermediate = false;

					}
				}
			}
			this.props.gradeLevels.isGradeLevelIntermediate = false;
			this.props.gradeLevels.indeterminate = false
			this.props.gradeLevels.isAllChecked = true;
			this.setState({ isBubbleClicked: !this.state.isBubbleClicked })
		} else { // if the all check box is true (isAllChecked === true) 
			// FOR LOOP TO LOOP OVER GRADE LEVELS 
			for (let i = 0; i < this.props.gradeLevels.gradeLevels.length; i++) {
				this.props.gradeLevels.gradeLevels[i].isGradeLevelSelected = false;

				// FOR LOOP TO LOOP OVER GRADE NUMBERS 
				for (let j = 0; j < this.props.gradeLevels.gradeLevels[i].grades.length; j++) {
					this.props.gradeLevels.gradeLevels[i].grades[j].isGradeSelected = false;
					// FOR LOOP TO LOOP OVER GROUPS 
					for (let k = 0; k < this.props.gradeLevels.gradeLevels[i].grades[j].groups.length; k++) {
						this.props.gradeLevels.gradeLevels[i].grades[j].groups[k].isGroupSelected = false;
						//     this.props.gradeLevels[i].grades[j].groups[k].isGradeLevelIntermediate= true;
					}
				}
			}
			this.props.gradeLevels.indeterminate = false;
			this.props.gradeLevels.isAllChecked = false;
			this.setState({ isBubbleClicked: !this.state.isBubbleClicked })
		}
	}

	// SELECTING AND DE-SELECTING OF INDIVIDUAL BUBBLES (TOGGLING)

	// CHECK BOX (TOGGLING)
	onCheckboxClicked = (selectedObj) => {
		let incompleteGrades = undefined;
		if (this.props.gradeLevels.isSubset != null) {
			let masterGradeObj = lodashUtil.find(this.props.activeSchool.school_master.gradeLevels, ["levelName", selectedObj.levelName]);
			if (masterGradeObj !== undefined) {
				if (selectedObj.grades.length !== masterGradeObj.grades.length) {
					incompleteGrades = true;
				}
			}
		}

		let allCheckBoxFlag = true
		if (selectedObj.isGradeLevelSelected === true) {
			selectedObj.isGradeLevelSelected = false;
			this.props.gradeLevels.isAllChecked = false;
			this.props.gradeLevels.indeterminate = false;
			for (let i = 0; i < this.props.gradeLevels.gradeLevels.length; i++) {
				if (this.props.gradeLevels.gradeLevels[i].isGradeLevelSelected === true || this.props.gradeLevels.gradeLevels[i].isGradeLevelIntermediate === true) {
					this.props.gradeLevels.indeterminate = true;
					break;
				}
			}
			this.setState({ isBubbleClicked: !this.state.isBubbleClicked });
			this.checkBoxAdaptor(selectedObj);
		} else if (selectedObj.isGradeLevelSelected === false) {
			if (incompleteGrades != undefined) {
				selectedObj.isGradeLevelSelected = false;
				selectedObj.isGradeLevelIntermediate = !selectedObj.isGradeLevelIntermediate;
				selectedObj = gradePickerUtil.gradeLevelObjectToBeChangedToTrue(selectedObj);
				this.setState({ isBubbleClicked: !this.state.isBubbleClicked })
			} else {
				selectedObj.isGradeLevelSelected = true;
				selectedObj.isGradeLevelIntermediate = false;
				this.checkBoxAdaptor(selectedObj);
			}
			for (let i = 0; i < this.props.gradeLevels.gradeLevels.length; i++) {
				if (this.props.gradeLevels.gradeLevels[i].isGradeLevelSelected === false) {
					allCheckBoxFlag = false;
					this.props.gradeLevels.indeterminate = true;
					break;
				}
			}
			if (allCheckBoxFlag === true) {
				this.props.gradeLevels.indeterminate = false;
				if (this.props.gradeLevels.isSubset != undefined) {
					this.props.gradeLevels.isAllChecked = false;
				} else {
					this.props.gradeLevels.isAllChecked = true
				}
				this.setState({ isBubbleClicked: !this.state.isBubbleClicked })
			}
		}
	}

	// GRADE NUMBERS (TOGGLING)
	onGradeNumberBubbleClick = (selectedObj, parentObj) => {
		selectedObj.isGradeSelected = !(selectedObj.isGradeSelected)
		this.setState({ isBubbleClicked: !this.state.isBubbleClicked })
		this.gradeNumberAdaptor(selectedObj);
		this.deselectionGradeNumber(selectedObj, parentObj);
	}

	// GROUPS (TOGGLING)
	onGroupBubbleClick = (selectedObj, parentObj, grandParentObj) => {
		selectedObj.isGroupSelected = !(selectedObj.isGroupSelected);
		this.setState({ isBubbleClicked: !this.state.isBubbleClicked });
		this.deselectionGradeGroups(selectedObj, parentObj, grandParentObj);
	}

	//DE-SELECTION 

	//GRADE 
	deselectionGradeNumber = (selectedObj, parentObj) => {
		let incompleteGrades = undefined;
		if (this.props.gradeLevels.isSubset != null) {
			let masterGradeObj = lodashUtil.find(this.props.activeSchool.school_master.gradeLevels, ["levelName", parentObj.levelName]);
			if (masterGradeObj !== undefined) {
				if (parentObj.grades.length !== masterGradeObj.grades.length) {
					incompleteGrades = true;
				}
			}
		}

		if (selectedObj.isGradeSelected === false) {
			parentObj.isGradeLevelSelected = false;
			parentObj.isGradeLevelIntermediate = false;
			this.props.gradeLevels.isAllChecked = false;
			this.props.gradeLevels.indeterminate = false;
			for (let i = 0; i < parentObj.grades.length; i++) {
				if (parentObj.grades[i].isGradeSelected === true || parentObj.grades[i].isGradeLevelIntermediate === true) {
				}
				for (let j = 0; j < parentObj.grades[i].groups.length; j++) {
					if (parentObj.grades[i].groups[j].isGroupSelected === true) {
						parentObj.isGradeLevelIntermediate = true;
						this.props.gradeLevels.indeterminate = true;
					}
				}

			}
			for (let i = 0; i < this.props.gradeLevels.gradeLevels.length; i++) {
				if (this.props.gradeLevels.gradeLevels[i].isGradeLevelSelected === true || this.props.gradeLevels.gradeLevels[i].isGradeLevelIntermediate) {
					this.props.gradeLevels.indeterminate = true;
				}
			}

			this.setState({ isBubbleClicked: !this.state.isBubbleClicked });
		}
		else {
			let parentObjFlag = true;
			let gradeLevelsFlag = true;
			let isGradeLevelIntermediateFlag = true;
			//LOOP OVER GRADE NUMBERS TO SET A FLAG TO SEE IF IT IS TURE OR FALSE 
			//IF ALL THE GRADE NUMBER IS TRUE THEN CAHNGE THE BOX TO TICK 
			for (let i = 0; i < parentObj.grades.length; i++) {
				if (parentObj.grades[i].isGradeSelected === false) {
					parentObjFlag = false;
					parentObj.isGradeLevelIntermediate = true
				}
			}
			if (parentObjFlag === true) {
				if (incompleteGrades != undefined) {
					parentObj.isGradeLevelIntermediate = true;
					parentObj.isGradeLevelSelected = false;
				} else {
					parentObj.isGradeLevelIntermediate = false;
					parentObj.isGradeLevelSelected = true;
				}

				this.setState({ isBubbleClicked: !this.state.isBubbleClicked })
			}

			//LOOP OVER THE GRADE LEVELS TO SET THE FLAG
			for (let i = 0; i < this.props.gradeLevels.gradeLevels.length; i++) {
				if (this.props.gradeLevels.gradeLevels[i].isGradeLevelSelected === false) {
					gradeLevelsFlag = false;
					this.props.gradeLevels.indeterminate = true;
				}
			}
			if (gradeLevelsFlag === true) {
				if (this.props.gradeLevels.isSubset != undefined) {
					this.props.gradeLevels.isAllChecked = false;
				} else {
					this.props.gradeLevels.isAllChecked = true
				}
				this.props.gradeLevels.indeterminate = false;
				this.props.gradeLevels.isGradeLevelIntermediateFlag = false;
				this.setState({ isBubbleClicked: !this.state.isBubbleClicked })
			}
		}
	}

	// GROUPS!!
	deselectionGradeGroups = (selectedObj, parentObj, grandParentObj) => {
		if (selectedObj.isGroupSelected === false) {
			parentObj.isGradeSelected = false;
			parentObj.isGradeLevelIntermediate = false;
			grandParentObj.isGradeLevelSelected = false;
			grandParentObj.isGradeLevelIntermediate = false;
			this.props.gradeLevels.indeterminate = false;

			this.props.gradeLevels.isAllChecked = false;
			for (let j = 0; j < parentObj.groups.length; j++) {
				if (parentObj.groups[j].isGroupSelected === true) {
					parentObj.isGradeLevelIntermediate = true;
					this.props.gradeLevels.indeterminate = true;
					grandParentObj.isGradeLevelIntermediate = true;
				}
			}
			for (let i = 0; i < grandParentObj.grades.length; i++) {
				if (grandParentObj.grades[i].isGradeSelected === true) {
					this.props.gradeLevels.indeterminate = true;
					parentObj.isGradeLevelIntermediate = true;
					grandParentObj.isGradeLevelIntermediate = true;
				}
			}
			for (let i = 0; i < this.props.gradeLevels.gradeLevels.length; i++) {
				if (this.props.gradeLevels.gradeLevels[i].isGradeLevelSelected === true || this.props.gradeLevels.gradeLevels[i].isGradeLevelIntermediate === true) {
					this.props.gradeLevels.indeterminate = true;
				}
			}
			this.setState({ isBubbleClicked: !this.state.isBubbleClicked });
		} else {
			let parentObjFlag = true;
			let grandParentObjFlag = true;
			let gradeLevelsFlag = true;

			//LOOP OVER GROUPS AND SET A FLAG TO BE TRUE OR FALSE 
			for (let j = 0; j < parentObj.groups.length; j++) {
				if (parentObj.groups[j].isGroupSelected === false) {
					parentObjFlag = false;
					parentObj.isGradeLevelIntermediate = true;
				}
			}
			if (parentObjFlag === true) {
				parentObj.isGradeSelected = true;
				parentObj.isGradeLevelIntermediate = true;
				this.setState({ isBubbleClicked: !this.state.isBubbleClicked })
			}

			// LOOP OVER GRADE NUMEBRS AND SET A FLAG
			for (let i = 0; i < grandParentObj.grades.length; i++) {
				if (grandParentObj.grades[i].isGradeSelected === false) {
					grandParentObjFlag = false;
					grandParentObj.isGradeLevelIntermediate = true;
					this.props.gradeLevels.indeterminate = true;
				}
			}
			if (grandParentObjFlag === true) {
				grandParentObj.isGradeLevelIntermediate = false;
				grandParentObj.isGradeLevelSelected = true;
				this.setState({ isBubbleClicked: !this.state.isBubbleClicked })
			}

			//LOOP OVER THE GRADE LEVELS TO SELECT THE BUBBLE AND ALSO TO SET THE FLAG
			for (let i = 0; i < this.props.gradeLevels.gradeLevels.length; i++) {
				if (this.props.gradeLevels.gradeLevels[i].isGradeLevelSelected === false) {
					gradeLevelsFlag = false;
				}
			}
			if (gradeLevelsFlag === true) {
				parentObj.isGradeLevelIntermediate = false;
				this.props.gradeLevels.indeterminate = false;
				if (this.props.gradeLevels.isSubset != undefined) {
					this.props.gradeLevels.isAllChecked = false;
				} else {
					this.props.gradeLevels.isAllChecked = true
				}
				this.setState({ isBubbleClicked: !this.state.isBubbleClicked })
			}
		}
	}

	//ADAPTOR (SELECTING)

	checkBoxAdaptor = (selectedObj) => {
		if (selectedObj.isGradeLevelSelected === true) {
			for (let i = 0; i < selectedObj.grades.length; i++) {
				selectedObj.grades[i].isGradeSelected = true;
				this.gradeNumberAdaptor(selectedObj.grades[i]);
			}
			this.setState({ isBubbleClicked: !this.state.isBubbleClicked })

		} else {
			for (let i = 0; i < selectedObj.grades.length; i++) {
				selectedObj.grades[i].isGradeSelected = false;
				selectedObj.grades[i].isGradeLevelIntermediate = true;
				this.gradeNumberAdaptor(selectedObj.grades[i]);
			}
			this.setState({ isBubbleClicked: !this.state.isBubbleClicked })
		}
	}
	gradeNumberAdaptor = (selectedObj) => {
		if (selectedObj.isGradeSelected === true) {
			for (let i = 0; i < selectedObj.groups.length; i++) {
				selectedObj.groups[i].isGroupSelected = true;
			}
			this.setState({ isBubbleClicked: !this.state.isBubbleClicked })
		} else {
			for (let i = 0; i < selectedObj.groups.length; i++) {
				selectedObj.groups[i].isGroupSelected = false;
			}
			this.setState({ isBubbleClicked: !this.state.isBubbleClicked })
		}

	}

	//MAPING OF GRADE LEVELS, GRADE NUMBERS AND GRADE GROUPS.

	//CHECKBOXES
	getGradeLevels = (obj, grandParentObj) => {
		return (
			<MuiGrid container xs={12} >
				<MuiGrid item xs={12}>
					<MuiFormControlLabel
						control={
							<CheckBox
								selectedObj={obj}
								checked={obj.isGradeLevelSelected}
								indeterminate={obj.isGradeLevelIntermediate}
								onClick={() => this.onCheckboxClicked(obj)}
								value={obj.groupNumber}
								color="primary"
							/>
						}
						label={<MuiTypography variant='h6'>{obj.levelName} </MuiTypography>} />
				</MuiGrid>
				<MuiGrid item xs={12} style={{ background: theme.palette.primary.lightest, margin: 1 }} >
					{this.getGrades(obj, grandParentObj)}
				</MuiGrid>
			</MuiGrid>
		)
	}

	getGrades = (obj) => {
		return (
			<MuiGrid container xs id="grid">

				{obj.grades.map((gradeNumber) => {
					return (
						<MuiGrid container xs direction="row" alignContent="flex-start" >
							{this.state.showDropDown ? <MuiGrid container direction="column" id='dropDown'>
								{this.getGradeGroups(gradeNumber, obj)}
							</MuiGrid> :
								<MuiGrid item  >
									<BubbleComponent label={gradeNumber.gradeName} isSelected={gradeNumber.isGradeSelected} onBubbleClick={this.onGradeNumberBubbleClick} selectedObj={gradeNumber} parentObj={obj} />
								</MuiGrid>
							}
						</MuiGrid>
					)
				})}

			</MuiGrid>
		)

	}
	getGradeGroups = (obj, parentObj) => {
		return (
			<MuiGrid container >
				<MuiGrid item xs >
					{obj.groups.map((group) => {
						return (
							<MuiGrid item >
								<BubbleComponent
									displayGroupName={`${obj.gradeName}-${group.groupName}`}
									label={group.groupName}
									isSelected={group.isGroupSelected}
									onBubbleClick={this.onGroupBubbleClick}
									selectedObj={group}
									parentObj={obj}
									grandParentObj={parentObj} />
							</MuiGrid>
						)
					})}
				</MuiGrid>
			</MuiGrid>
		)
	}

	// saving details in a different format 
	savingData = () => {
		const gradeDetails = {
			allGrades: true,
			gradeLevels: [],
			grades: []


		}

		//ALL GRADE SELECTED
		if (this.props.gradeLevels.isAllChecked === false) {
			gradeDetails.allGrades = false;

			//TO GET THE GRADE LEVEL

			// IF GRADE LEVEL IS TRUE THEN CF WILL COME HERE
			for (let i = 0; i < this.props.gradeLevels.gradeLevels.length; i++) {
				if (this.props.gradeLevels.gradeLevels[i].isGradeLevelSelected === true) {
					gradeDetails.gradeLevels.push({ level: this.props.gradeLevels.gradeLevels[i].levelName });
				}

				// IF GRADE LEVEL IS FALSE THEN CF ENTERS ELSE IF
				else { //(this.props.gradeLevels[i].isGradeLevelSelected === false)
					for (let j = 0; j < this.props.gradeLevels.gradeLevels[i].grades.length; j++) {

						// IF GRADE NUMBERS IS TRUE THEN CF ENTERS HERE
						if (this.props.gradeLevels.gradeLevels[i].grades[j].isGradeSelected === true) {
							gradeDetails.grades.push({ grade: this.props.gradeLevels.gradeLevels[i].grades[j].gradeName });
						}
						//IF GRADE NUMBERS IS FALSE THEN CF ENTERS HERE 
						else if (this.props.gradeLevels.gradeLevels[i].grades[j].isGradeSelected === false) {
							//create grade obj into grade details
							let gradeObj = {
								grade: this.props.gradeLevels.gradeLevels[i].grades[j].gradeName,
								groups: []
							}
							let isGradeObj = false;
							// LOOP TO GET THE GROUP NAME
							for (let k = 0; k < this.props.gradeLevels.gradeLevels[i].grades[j].groups.length; k++) {
								if (this.props.gradeLevels.gradeLevels[i].grades[j].groups[k].isGroupSelected === true) {
									isGradeObj = true;
									let groupObj = {
										groupCode: this.props.gradeLevels.gradeLevels[i].grades[j].groups[k].groupName
									}

									gradeObj.groups.push(groupObj);
								}
							}
							if (isGradeObj === true) {
								gradeDetails.grades.push(gradeObj)
							}
						}
					}
				}
			}
		}
		;
		this.props.onClickOfSaveInGradePicker(gradeDetails)
	}


	render() {
		const { i18n } = this.props
		return (
			<div>
				{this.props.gradeLevels && <MuiDialog
					id="dialog"
					fullWidth={true}
					maxWidth={'lg'}
					open={this.props.open}
					keepMounted
					//onClose={this.handleClose}
					aria-lablelledby="alert-dialog-slide-title"
					aria-describedby="alert-dialog-slide-description">
					<MuiDialogTitle style={{ background: theme.palette.grey.dark }} >
						<MuiGrid container>
							<MuiGrid item xs container alignItems="center" justify="center" >
								<MuiTypography style={{ fontFamily: "Arial", fontSize: '15px', color: "white" }}>
									{i18n.grade.gradePickerDialogTitle}
								</MuiTypography>
							</MuiGrid>


						</MuiGrid>
					</MuiDialogTitle>
					<MuiDialogContent>
						<MuiTypography variant={theme.typographyStyles.BODY1} style={theme.gridHeaderTextStyle}>

							{/* main container */}
							<MuiGrid container xs={12}>
								{this.props.subTitle !== undefined && this.props.subTitle!=='' && <MuiGrid item xs >
									<MuiTypography style={{ fontFamily: "Arial", fontSize: '15px', color: theme.palette.primary.main }}>
									{this.props.subTitle}
								</MuiTypography>
								</MuiGrid>}
								{/* ALL container */}
								<MuiGrid container xs={12}>
									{this.props.gradeLevels.isSubset != null ?
										null
										:
										<MuiGrid item xs={12}>
											<MuiFormControlLabel
												control={
													<CheckBox
														id="checkBox"
														checked={this.props.gradeLevels.isAllChecked}
														indeterminate={this.props.gradeLevels.indeterminate}
														onClick={() => this.allCheckboxToggle()}
														value="all" color="primary" />
												}

												label={<MuiTypography variant='h5'>All</MuiTypography>} />
										</MuiGrid>}

									<MuiGrid container xs style={{ width: '100%' }}>

										{this.props.gradeLevels != null && this.props.gradeLevels.gradeLevels != null && this.props.gradeLevels.gradeLevels.map((obj) => {
											return (
												<MuiGrid style={{ margin: 1, width: (obj.grades != undefined ? ((obj.grades.length * 4) + ((obj.grades.length > 1 && obj.grades.length <= 3) ? 4 : 10)) + '%' : '15%') }}>

													{
														this.getGradeLevels(obj)
													}

												</MuiGrid>
											)
										})}

									</MuiGrid>
								</MuiGrid>
							</MuiGrid>
							<MuiGrid container xs={12} alignContent="center" justify="flex-end" spacing={2} >

								{/* Not allowing the user to create the calendar for groups. */}
								{this.props.stopSelectionForGroups == null ?
									<MuiGrid item id="toggle" onClick={() => this.toggleDropDown()}>
										{this.state.showDropDown == true ?
											<MuiGrid item>
												<MuiKeyboardArrowUp color='primary' />
											</MuiGrid>
											:
											<MuiKeyboardArrowDown color='primary' />}
									</MuiGrid>
									:
									null
								}
								<MuiGrid item >
									<MuiButton id="cancel"
										style={theme.secondaryButtonStyle} onClick={() => this.props.handleClose()}>
										{i18n.commonTexts.cancel}
									</MuiButton>
								</MuiGrid>
								<MuiGrid item >
									<MuiButton id="save"
										style={theme.primaryButtonStyle} onClick={() => this.savingData()}>
										{i18n.commonTexts.apply}
									</MuiButton>
								</MuiGrid>
							</MuiGrid>

						</MuiTypography>
					</MuiDialogContent>
				</MuiDialog>}
			</div >
		)
	}
}

export default GradePickerComponent